import { render } from "./GeometryContainer.vue?vue&type=template&id=2bf8fa66"
import script from "./GeometryContainer.vue?vue&type=script&lang=js"
export * from "./GeometryContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__